@switch (show) {
  @case (EntranceStates.CREATE_ORGANIZATION) {
    <app-new-organization/>
  }
  @case (EntranceStates.SELECT_ORGANIZATION) {
    <app-select-organization
      [isNewOrgCanBeCreated]="isNewOrgCanBeCreated"
      [availableOrganization]="organizations"
      (createOrganizationEmitter)="show = EntranceStates.CREATE_ORGANIZATION"
      (selectOrganizationEmitter)="selectOrganization($event)"
    />
  }
  @case (EntranceStates.ORGANIZATION_IS_SPECIFIED) {
    <!-- Software cards -->
    <div class="wrapper h-full">
      <div class="flex justify-center items-center self-stretch flex-grow green-scroll-mobile center-screen" style="font-size:{{fontSizes.general}}">
        <div class="flex flex-col">
          <div class="cards-container">
            <div class="cards-title desktop">FUND PERFORMANCE</div>
            <div class="cards-wrapper">
              <!--Fund performance-->
  <!--            TODO: Add redirect to Fund Budget-->
              <app-modal-entrance-card
                data-qa="modal-entrance-fund-performance"
                [title]="'Fund performance'"
                [status]="'ai'"
                (activateAiTooltipEmitter)="activateAiTooltip($event)"
                (deactivateAiTooltipEmitter)="deactivateAiTooltip()"
                (click)="redirectTo(MODELS_URLS.BASE)"
              />
              <!--KPI-->
              <app-modal-entrance-card
                data-qa="modal-entrance-kpi"
                [title]="'Portfolio KPIs'"
                [status]="'ai'"
              />
              <!--FS-->
              <app-modal-entrance-card
                data-qa="modal-entrance-financial-statements"
                [title]="'Financial statements'"
                [status]="'request-demo'"
              />
              <!-- -------- MARKET ANALYSIS ------------------- --->
              <app-modal-entrance-card
                data-qa="modal-entrance-market-analysis"
                [title]="'Market analysis'"
              />
            </div>
            <div class="cards-title desktop">INVESTOR RELATIONS</div>
            <div class="cards-wrapper">
              <!-- ------------------- INVESTOR PORTAL ------------------- --->
              <app-modal-entrance-card
                data-qa="modal-entrance-investors-portal"
                [title]="'Investor portal'"
              />
              <!-- ------------------- PDF ------------------- --->
              <app-modal-entrance-card
                data-qa="modal-entrance-pdf-report-generator"
                [title]="'PDF report generator'"
              />
              <!-- ------------------- DATA ROOM ------------------- --->
              <app-modal-entrance-card
                data-qa="modal-entrance-data-room"
                [title]="'Data room'"
                [status]="'ai'"
              />
              <!-- ------------------- INVESTOR ONBOARDING ------------------- --->
              <app-modal-entrance-card
                data-qa="modal-entrance-investor-onboarding"
                [title]="'Investor onboarding'"
                [status]="'demo'"
                (click)="redirectTo(FRONT_URLS.INVESTOR_ONBOARDING)">
              </app-modal-entrance-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}



@if (tooltipSettings.show) {
  <app-tooltip
    [coordinates]="tooltipSettings.coordinates"
    [title]="tooltipSettings.title"
    [isParentPositionRelative]="true"
    [positionType]="'left'"
    [xShift]="'2rem'"
    [yShift]="'-0.4rem'"
  />
}
